var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("label", [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.asphaltType.active,
          expression: "asphaltType.active",
        },
      ],
      staticClass: "u-no-margin--bottom",
      attrs: { type: "checkbox", disabled: _vm.asphaltType.disabled },
      domProps: {
        checked: Array.isArray(_vm.asphaltType.active)
          ? _vm._i(_vm.asphaltType.active, null) > -1
          : _vm.asphaltType.active,
      },
      on: {
        change: [
          function ($event) {
            var $$a = _vm.asphaltType.active,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 &&
                  _vm.$set(_vm.asphaltType, "active", $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  _vm.$set(
                    _vm.asphaltType,
                    "active",
                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                  )
              }
            } else {
              _vm.$set(_vm.asphaltType, "active", $$c)
            }
          },
          _vm.onActiveChange,
        ],
      },
    }),
    _vm._v("\n    " + _vm._s(_vm.asphaltType.name) + "\n"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }